import {Injectable} from '@angular/core';
import {StorageMap} from '@ngx-pwa/local-storage';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageIndexedService {
  public constructor(public storagemap: StorageMap) {
  }

  getFromStorage(key: string): Observable<any> {
    return this.storagemap.get(key);
  }

  setToStorage(key: string, value: any) {
    return this.storagemap.set(key, value);
  }

  clearStorage() {
    return this.storagemap.clear();
  }

  removeFromStorage(key: string) {
    return this.storagemap.delete(key);
  }

  keyExistsInStorage(key: string) {
    return this.storagemap.has(key);
  }

  setToSession(key: string, value: any) {
    return sessionStorage.setItem(key, JSON.stringify(value));
  }

  getFromSession(key: string) {
    const value = sessionStorage.getItem(key);
    if (value != null && value !== undefined) {
      return JSON.parse(value);
    } else {
      return null;
    }
  }

  removeFromSession(key: string) {
    return sessionStorage.removeItem(key);
  }

  clearSession() {
    return sessionStorage.clear();
  }
}
